import { List, Edit, Create, SimpleForm, TextInput, NumberInput, required } from 'react-admin';
import { Stack } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';
import { ReorderableDatagrid, imageCell } from '../../components/ReorderableDatagrid.jsx';

const LevelCardList = () => (
  <List sort={{ field: 'sortOrder', order: 'ASC' }} perPage={50} pagination={false} empty={false}>
    <ReorderableDatagrid
      columns={[
        { key: 'image', header: 'Image', width: 100, render: (r) => imageCell(r.image) },
        { key: 'title', header: 'Title', render: (r) => r.title },
        { key: 'ageRange', header: 'Age range', render: (r) => r.ageRange || '—' },
      ]}
    />
  </List>
);

const LevelCardForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 720 }}>
    <ImageUploadInput source="image" label="Card image" />
    <Stack direction="row" spacing={2}>
      <TextInput source="ageRange" label="Age range (e.g. 3–5 years)" sx={{ width: 220 }} />
      <TextInput source="title" label="Title" validate={required()} fullWidth />
    </Stack>
    <TextInput source="description" label="Description" multiline minRows={3} fullWidth />
    <TextInput source="link" label="Link / URL slug" fullWidth helperText="Where users go when they tap this card. Example: /academics/pg-kg" />
    <NumberInput source="sortOrder" label="Sort order" defaultValue={0} />
  </Stack>
);

const LevelCardEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><LevelCardForm /></SimpleForm>
  </Edit>
);
const LevelCardCreate = () => (
  <Create redirect="list">
    <SimpleForm><LevelCardForm /></SimpleForm>
  </Create>
);

export default {
  list: LevelCardList,
  edit: LevelCardEdit,
  create: LevelCardCreate,
  icon: SchoolIcon,
  options: { label: 'Level cards' },
};
